import { client } from "./client";

// Redundant loginUser removed in favor of obtainToken


export const registerUser = async (userData) => {
    const response = await client.post("/api/users/", userData);
    return response.data;
};

export const fetchUserProfile = async () => {
    const response = await client.get("/api/users/me/");
    return response.data;
};

export const updateUserProfile = async (payload) => {
    const response = await client.put("/api/users/me/", payload);
    return response.data;
};

export const obtainToken = async ({ email, password }) => {
    const response = await client.post("/api/users/token/", { email, password });
    return response.data;
};

export const fetchUserReservations = async () => {
    const response = await client.get("/api/reservations/");
    return response.data;
};

// Takes a password OR a Google credential: an account created through Google
// has no usable password, so check_password() there is False for every input
// and the server asks for a fresh Google token instead. Only the key that was
// actually supplied is sent -- the server branches on which one arrives.
export const deleteAccount = async ({ password, credential }) => {
    const data = credential !== undefined ? { credential } : { password };
    const response = await client.delete("/api/users/me/", { data });
    return response.data;
};

// _skipAuth: these run while logged out. Without it the response interceptor
// would try to refresh a token on 401 and bounce the user to the login modal.
export const requestPasswordReset = async ({ email }) => {
    const response = await client.post(
        "/api/users/password-reset/",
        { email },
        { _skipAuth: true },
    );
    return response.data;
};

export const confirmPasswordReset = async ({ uid, token, password }) => {
    const response = await client.post(
        "/api/users/password-reset/confirm/",
        { uid, token, new_password: password },
        { _skipAuth: true },
    );
    return response.data;
};

export const verifyEmail = async ({ uid, token }) => {
    const response = await client.post(
        "/api/users/verify-email/",
        { uid, token },
        { _skipAuth: true },
    );
    return response.data;
};

export const resendVerification = async () => {
    const response = await client.post("/api/users/verify-email/resend/");
    return response.data;
};

// Returns a fresh token pair: the server revokes every outstanding refresh
// token (including this tab's) when the password changes, so the caller must
// store what comes back or the next request will 401.
export const changePassword = async ({ oldPassword, newPassword }) => {
    const response = await client.put("/api/users/change-password/", {
        old_password: oldPassword,
        new_password: newPassword,
    });
    return response.data;
};

// Both Google endpoints run while logged out, so both need _skipAuth for the
// same reason the password-reset calls above do.
export const googleLogin = async ({ credential }) => {
    const response = await client.post(
        "/api/users/google/",
        { credential },
        { _skipAuth: true },
    );
    return response.data;
};

// Step two of the unverified-account conflict. `password` is only meaningful
// when keepPassword is true, so it is left out otherwise rather than sent as
// a value the server will ignore.
export const googleLink = async ({ linkToken, keepPassword, password }) => {
    const payload = { link_token: linkToken, keep_password: keepPassword };
    if (keepPassword) {
        payload.password = password;
    }
    const response = await client.post(
        "/api/users/google/link/",
        payload,
        { _skipAuth: true },
    );
    return response.data;
};
